import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { v4 } from "uuid";
import { WORK_FLOW_TYPE } from "../../config/cacheKey";
import {
  GetCartableActionsResponse,
  GetCoreInformationResponse,
  ReferenceKey,
} from "../../models/cartable.model";
import { GetLoanCommentsResponse } from "../../models/chat.model";
import { ApiResultModel } from "../../models/common.model";
import {
  GetCancellationReasonsResponse,
  GetInstallmentTableRequest,
  GetInstallmentTableResponse,
  GetLegacyContractsResponse,
} from "../../models/loan.model";
import {
  GetAppInformation,
  GetCoreInformation,
} from "../../services/cartable.service";
import { GetLoanComments } from "../../services/chat.service";
import {
  GetCancellationReasons,
  GetLegacyContracts,
} from "../../services/loan.service";
import LoanCancelationModal from "../cancleLoan/components/LoanCancelationModal";
import CommentSideMenu from "../comments/commentSideMenu";
import ActionTabs from "./actionCopmonets.tsx/actionTab/actionTabs";
import FacilityFileDetail from "./facilityFileDetail";
import HeaderInfo from "./headerInfo";
import ParsLisver from "./parsLisver";
import ScheduleInstallment from "./scheduleInstallment";
import TabsPanel from "./tabsPanel";

function _detailFindPage(props: any) {
  return (
    <div
      // className="cardDetail "
      style={{ background: "#F9F6F7", padding: "2px !important" }}
    >
      <div style={{ background: "#F9F6F7" }}>
        <Grid
          container
          xs={12}
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={{ backgroundColor: "#F9F6F7" }}
        >
          <Grid item xs={4} sm={6} md={4}>
            <Typography className=" " style={{ marginLeft: "2vh" }}>
              <AccountCircleIcon
                style={{ width: "46px", height: "46px", color: "#9AAFC4" }}
              />
              <span className="detailPageTitle" style={{ marginRight: "1vh" }}>
                {props.requestDetail?.customerFullName}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={4} sm={6} md={4}>
            <Typography
              className=" "
              style={{ marginLeft: "2vh", marginTop: "1.8vh" }}
            >
              <b className="detailPageTitle">کد ملی: </b>
              <span className="detailPageTitle">
                {props.requestDetail?.customerNationalCode}
              </span>
            </Typography>
          </Grid>
          <Grid item xs={4} sm={6} md={4}>
            <Typography
              className=" "
              style={{
                marginLeft: "2vh",
                marginTop: "1.8vh",
                whiteSpace: "nowrap",
              }}
            >
              <b className="detailPageTitle"> آخرین وضعیت: </b>
              <span className="detailPageTitle">
                {props.requestDetail?.loanRequestStatusTitle}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

function DetailFindPage({ cartable }: DetailPagePropsInterface) {
  const [showInstallmentComponent, setShowInstallmentComponent] = useState(
    false
  );
  const [installmentsTable, setInstallmentsTable] = useState(false);
  const [isCore, setIsCore] = useState(true);
  const queryClient = useQueryClient();
  let getCartableAction: string;
  getCartableAction = queryClient.getQueryData(WORK_FLOW_TYPE)!;
  const [parsLizverData, setParsLizverData] = useState<
    GetLegacyContractsResponse[]
  >();
  const [dataFlag, setDataFlag] = useState<string>("none");

  if (getCartableAction == null || getCartableAction == undefined) {
    getCartableAction = localStorage.getItem("setActivePage")!;
  }
  const history = useHistory<{
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    loanRequestId: number;
    natinalCode: string;
    from?: string;
    activeCancleButton?: boolean;
  }>();

  let fromPage;

  if (history?.location?.state !== undefined) {
    fromPage = history?.location?.state!.from;
  }

  const [flagActionTabs, setFlagActionTab] = useState(false);
  const [actionTabsData, setActionTabData] = useState();
  const [moveToEnd, setMoveToEnd] = useState<string>("");
  const id =
    history.location.state !== undefined
      ? history.location.state.id
      : window.sessionStorage.getItem("idFind") != undefined
      ? window.sessionStorage.getItem("idFind")
      : null;

  const loanRequestId =
    history.location.state !== undefined
      ? history.location.state.loanRequestId
      : window.sessionStorage.getItem("loanRequestId") != undefined
      ? Number(window.sessionStorage.getItem("loanRequestId"))
      : null;
  const natinalCode =
    history.location.state && history.location.state.natinalCode !== undefined
      ? history.location.state.natinalCode
      : window.sessionStorage.getItem("natinalCode") != undefined
      ? window.sessionStorage.getItem("natinalCode")
      : null;
  const [pageNumber, setPageNumber] = useState(
    history.location.state !== undefined ? history.location.state.pageNumber : 1
  );
  const requestPanelTabs = new ReferenceKey();
  const workFlowType = queryClient.getQueryData(WORK_FLOW_TYPE)!;
  requestPanelTabs.referenceKey = String(id);
  // if (performance.navigation.type === 1) {
  if (id == undefined) {
    history.push(`/Search/${cartable.cartable}`);
    queryClient.setQueryData(WORK_FLOW_TYPE, workFlowType);
  }
  const [dataGetCoreInformation, setDataGetCoreInformation] = useState<
    GetCoreInformationResponse
  >();
  const [dataGetInstallmentTable, setDataGetInstallmentTable] = useState<
    GetInstallmentTableResponse[]
  >();
  const [reload, setReload] = useState("");

  const [returnPageRef, setReturnPageRef] = useState(null);
  const [isChatShowed, setChatShowed] = useState(false);
  //***GetAppInformation */
  const {
    mutateAsync: getAppInformationMutation,
    isLoading: isMutatinApp,
  } = useMutation(GetAppInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data.isSuccess) {
        setDataGetCoreInformation(data.data);
      } else {
        history.push("/Search/CustomerSearch");
      }
    },
  });

  const [dataGetInstallmentCheque, setDataGetInstallmentCheque] = useState();
  const request = new GetInstallmentTableRequest();

  const [isReloadBtnDisable, setReloadBtnDisable] = useState(true);
  const [lastMessageKey, setLastMessageKey] = useState<string>("");
  const [fetchDate, setFetchDate] = useState<any>();
  const [messages, setMessages] = useState<GetLoanCommentsResponse[]>([]);
  const [allMessages, setAllMessages] = useState<GetLoanCommentsResponse[]>([]);
  const [cancalationReasonsList, setCancalationReasonsList] = useState<
    GetCancellationReasonsResponse[]
  >([]);
  const [openCancleModal, setOpenCancleModal] = useState(false);
  const {
    mutateAsync: GetLegacyContractsMutation,
    isLoading: isMutatin,
  } = useMutation(GetLegacyContracts, {
    onSuccess: (data: ApiResultModel<GetLegacyContractsResponse[]>) => {
      if (data.isSuccess) {
        if (data.data.length > 0) {
          setParsLizverData(data.data);
        } else {
          setDataFlag("null");
        }
      } else if (!data.isSuccess) {
        setDataFlag("isNotSuccess");
      }
    },
  });
  const activeCancleButton = history?.location?.state?.activeCancleButton
    ? history?.location?.state?.activeCancleButton
    : JSON.parse(localStorage.getItem("activeCancleButton")!)
        ?.activeCancleButton;
  //***GetCoreInformation */
  const {
    mutateAsync: getCoreInformationMutation,
    isLoading: isMutatinCore,
    isSuccess: infoSuccess,
  } = useMutation(GetCoreInformation, {
    onSuccess: (data: ApiResultModel<GetCoreInformationResponse>) => {
      if (data.isSuccess) {
        setDataGetCoreInformation(data.data);
        setChatShowed(true);
      } else if (getCartableAction == "SupplierSearch") {
        history.push("/Search/SupplierSearch");
      } else if (getCartableAction == "OnlineInstallment") {
        history.push("/Report/OnlineInstallment");
      }
    },
  });

  // get cancalation reasons
  useQuery<GetCancellationReasonsResponse[]>(
    "cancalationReasons",
    GetCancellationReasons,
    {
      enabled:
        infoSuccess &&
        dataGetCoreInformation?.loanRequestInfo?.canBeCancelled &&
        activeCancleButton,
      onSuccess(data) {
        if (data) {
          setCancalationReasonsList(data);
        }
      },
    }
  );

  useEffect(() => {
    return () => {
      // && history.location.pathname === "any specific path")
      if (history.action === "POP") {
        history.replace({
          pathname: history.location.pathname,
          state: {
            id: "",
            pageNumber: pageNumber,
            clickOnBack: true,
            loanRequestId: 0,
            natinalCode: "",
          },
        });
      }
    };
  }, [history]);

  useEffect(() => {
    if (id) {
      GetLegacyContractsMutation({
        customerNationalCode: natinalCode!,
        referenceKey: id,
      });
      if (
        cartable.cartable == "SupplierSearch" ||
        getCartableAction == "SupplierSearch"
      ) {
        getCoreInformationMutation(requestPanelTabs);
        request.coreReferenceKey = id;
        request.loanRequestId = loanRequestId!;
        // getInstallmentTableMutation(request);
        setIsCore(true);
      } else if (
        cartable.cartable == "CustomerSearch" ||
        getCartableAction == "CustomerSearch"
      ) {
        getAppInformationMutation(requestPanelTabs);
        request.appReferenceKey = id;
        request.loanRequestId = loanRequestId!;
        // getInstallmentTableMutation(request);
        setIsCore(false);
      } else if (getCartableAction == "OnlineInstallment") {
        getCoreInformationMutation(requestPanelTabs);
        request.coreReferenceKey = id;
        request.loanRequestId = loanRequestId!;
        // getInstallmentTableMutation(request);
      } else {
        getCoreInformationMutation(requestPanelTabs);
        request.coreReferenceKey = id;
        request.loanRequestId = loanRequestId!;
        // getInstallmentTableMutation(request);
      }
    }
  }, []);

  //*** */
  const [dataGetCartableActions, setDataGetCartableActions] = useState<
    GetCartableActionsResponse[]
  >();

  const child = (
    <_detailFindPage
      id={id}
      requestDetail={dataGetCoreInformation?.loanRequestInfo}
    />
  );
  const {
    mutate: GetLoanCommentsMutate,
    isLoading: commentsLoading,
  } = useMutation(GetLoanComments, {
    onSuccess: (data: GetLoanCommentsResponse[]) => {
      if (data) {
        setTimeout(() => setReloadBtnDisable(false), 2 * 60 * 1000);
        let MyDate = new Date();
        let Day = new Date().toLocaleDateString("fa-IR");
        let Hours;
        let Minutes;
        let Sec;

        MyDate.getSeconds() < 10
          ? (Sec = "0" + MyDate.getSeconds().toString())
          : (Sec = MyDate.getSeconds().toString());
        MyDate.getMinutes() < 10
          ? (Minutes = "0" + MyDate.getMinutes().toString())
          : (Minutes = MyDate.getMinutes().toString());
        MyDate.getHours() < 10
          ? (Hours = "0" + MyDate.getHours().toString())
          : (Hours = MyDate.getHours().toString());

        setFetchDate(Day + " - " + Hours + ": " + Minutes + ": " + Sec);

        setMessages(data);
        setAllMessages(data);
        setLastMessageKey(data[data.length - 1]?.key);
        setMoveToEnd(v4());
      }
    },
    onError: () => {
      setMoveToEnd(v4());
    },
  });

  useEffect(() => {
    if (requestPanelTabs.referenceKey !== undefined) {
      if (
        history.location.pathname ===
          "/loan/LoanRegistrationBySupplier1/loan-detail" ||
        history.location.pathname ===
          "/loan/LoanRegistrationBySupplier1/loan-detail-find" ||
        history.location.pathname ===
          "/loan/SupplierSettlementCartable1/loan-detail" ||
        history.location.pathname ===
          "/Search/SupplierSearch1/request-find-detail"
      ) {
        GetLoanCommentsMutate({
          referenceKey: requestPanelTabs.referenceKey,
        });
      }
    }
  }, [requestPanelTabs.referenceKey]);
  useEffect(() => {
    if (reload) {
      getCoreInformationMutation(requestPanelTabs);
    }
  }, [reload]);
  if (isMutatinApp || isMutatinCore) {
    return (
      <div>
        <Backdrop
          hidden={false}
          open={true}
          sx={{ color: "#fff", zIndex: () => 1 }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    );
  }

  return (
    <div id="screenView">
      {dataGetCoreInformation ? (
        <>
          <HeaderInfo
            referenceKey={id}
            setFlagActionTab={setFlagActionTab}
            setActionTabData={setActionTabData}
            flagActionTabs={flagActionTabs}
            setDataGetCoreInformation={setDataGetCoreInformation}
            dataGetCartableActions={dataGetCartableActions}
            setDataGetCartableActions={setDataGetCartableActions}
            getCartableAction={getCartableAction}
            findDetail={false}
            showInstallmentComponent={showInstallmentComponent}
            setDataGetInstallmentCheque={setDataGetInstallmentCheque}
            requestDetail={dataGetCoreInformation?.loanRequestInfo}
            isCore={isCore}
            printedData={dataGetCoreInformation}
            scheduleInstallmentData={dataGetInstallmentTable}
            test={setDataGetInstallmentTable}
            pathname={"detailFindPage"}
            setOpenCancleModal={setOpenCancleModal}
          />
          <FacilityFileDetail
            requestDetail={dataGetCoreInformation?.loanRequestInfo}
            child={child}
            showInstallmentComponent={setShowInstallmentComponent}
            setFlagActionTab={setFlagActionTab}
            setDataGetInstallmentTable={setDataGetInstallmentTable}
            isCore={isCore}
            installmentsTable={installmentsTable}
          />
        </>
      ) : (
        // <div className="spinner-container">
        //   <div className="loading-spinner"></div>
        //   <p>test</p>
        // </div>
        // <div className="content">
        <div className="load-wrapp classCenter"></div>
        // </div>
      )}
      {flagActionTabs && !showInstallmentComponent ? (
        <ActionTabs
          setFlagActionTab={setFlagActionTab}
          actionTabsData={actionTabsData}
          referenceKey={id}
          setDataGetCoreInformation={setDataGetCoreInformation}
          setDataGetCartableActions={setDataGetCartableActions}
          getCartableAction={getCartableAction}
        />
      ) : null}
      {dataGetCoreInformation?.loanRequestInfo.customerNationalCode && (
        <ParsLisver dataFlag={dataFlag} parsLizverData={parsLizverData!} />
      )}
      <br />
      {dataGetCoreInformation ? (
        showInstallmentComponent ? (
          <ScheduleInstallment
            data={dataGetInstallmentTable}
            setDataGetInstallmentTable={setDataGetInstallmentTable}
          />
        ) : (
          <TabsPanel panelTabs={dataGetCoreInformation} setReload={setReload} />
        )
      ) : null}
      {isChatShowed &&
        (cartable.cartable !== "CustomerSearch" ||
          getCartableAction !== "CustomerSearch") && (
          <CommentSideMenu
            referenceKey={requestPanelTabs.referenceKey}
            commentsLoading={commentsLoading}
            fetchDate={fetchDate}
            setFetchDate={setFetchDate}
            setMessages={setMessages}
            messages={messages}
            setAllMessages={setAllMessages}
            setLastMessageKey={setLastMessageKey}
            allMessages={allMessages}
            lastMessageKey={lastMessageKey}
            isReloadBtnDisable={isReloadBtnDisable}
            setReloadBtnDisable={setReloadBtnDisable}
            moveToEnd={moveToEnd}
          />
        )}

      <LoanCancelationModal
        cancellationReasonsList={cancalationReasonsList}
        openModal={openCancleModal}
        setOpenModal={setOpenCancleModal}
        referenceKey={requestPanelTabs?.referenceKey}
        setReload={setReload}
      />
    </div>
  );
}
interface DetailPagePropsInterface {
  cartable: any;
}
const mapStateToProps = ({ cartable }: DetailPagePropsInterface) => {
  return {
    cartable,
  };
};

export default withRouter(connect(mapStateToProps)(DetailFindPage));
